import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

const callCenterBreadcrumbs = generateBreadcrumbs({
  label: 'call_center.call_center',
  route: { name: 'call-center' },
});

const extensions_routes = {
  path: 'extensions',
  name: 'extensions',
  component: () => import('@/views/ExtensionsView.vue'),
  meta: {
    permissions: 'read-live-panel',
    breadcrumbs: callCenterBreadcrumbs({
      label: 'call_center.live_panel',
      route: { name: 'extensions' },
    }),
  },
};

export default extensions_routes;
